import './ContentEditable.css';

import React from 'react';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';

const LexicalContentEditable = ({ className }) => {
  return <ContentEditable className={className || 'ContentEditable__root'} />;
};

export default LexicalContentEditable;
